class ProductFeatureDetails extends HTMLElement {
  constructor() {
    super();
    // 初始化元素的状态或属性
    this.currentOptionHandle = document.querySelector('.swatch-container.color-swatch')?.querySelector('input[type=radio]:checked')?.getAttribute('data-color-handle') || '';
  }

  variantIdChangedUnsubscriber = undefined;

  connectedCallback() {
    // 元素被添加到DOM时调用
    // 事件订阅：监听变体切换
    this.variantIdChangedUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      let currColor = document.querySelector('.swatch-container.color-swatch')?.querySelector('input[type=radio]:checked')?.getAttribute('data-color-handle') || '';
      if(currColor && currColor != this.currentOptionHandle) {
        this.currentOptionHandle = currColor;
        this.showFeatureDetailsImage(this.currentOptionHandle);
      }
    });
    if(this.currentOptionHandle) {
      this.showFeatureDetailsImage(this.currentOptionHandle);
    }
    // 初始化元素
    this.init();
    // 添加 resize 事件监听器
    this.resizeListener = this.debounce(this.handleResize.bind(this), 200);
    window.addEventListener('resize', this.resizeListener);
  }

  disconnectedCallback() {
    // 元素从DOM中移除时调用
    // 取消订阅事件
    if (this.variantIdChangedUnsubscriber) {
      this.variantIdChangedUnsubscriber();
    }
    // 移除 slick 实例
    this.destroySlick(pfdImageWrapper);
    // 移除 resize 事件监听器
    window.removeEventListener('resize', this.resizeListener);
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      this.handleResize(); // 初始化时也执行一次 handleResize
      this.showFeatureDetailsImage(this.currColorOptionHandle);
    });
  }

  handleResize() {
    const pfdImageWrapper = $(this.querySelector('.pfd-imagelist-wrapper'));
    const windowWidth = window.innerWidth;
    if (windowWidth <= 820) {
      this.initSlick(pfdImageWrapper);
    } else if (windowWidth > 820) {
      this.destroySlick(pfdImageWrapper);
    }
  }

  initSlick(pfdImageWrapper) {
    pfdImageWrapper.on('init', () => {
      this.includeCarouselInstructions(pfdImageWrapper);
    });
    if (pfdImageWrapper.hasClass('slick-initialized')) {
      pfdImageWrapper.slick('unslick');
    }
    pfdImageWrapper.slick({
      infinite: true,
      draggable: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3000,
      prevArrow: '<button type="button" class="slick-prev" role="button" aria-label="Previous" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="product-feature-prev" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><title id="product-feature-prev">Product Image Prev</title><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon fill="currentColor" points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg><span hidden="hidden">Previous</span></button>',
      nextArrow: '<button type="button" class="slick-next" role="button" aria-label="Next" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="product-feature-next" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><title id="product-feature-next">Product Image Next</title><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon fill="currentColor" points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg><span hidden="hidden">Next</span></button>',
    });
  }

  destroySlick(pfdImageWrapper = $(this.querySelector('.pfd-imagelist-wrapper'))) {
    pfdImageWrapper.on('destroy', () => {
      this.removeCarouselInstructions(pfdImageWrapper);
    });
    if (pfdImageWrapper.hasClass('slick-initialized')) {
      pfdImageWrapper.slick('unslick');
    }
  }

  showFeatureDetailsImage(colorOptionHandle) {
    if(colorOptionHandle) {
      let pfdImageWrapper = $(this.querySelector('.pfd-imagelist-wrapper'));
      if(pfdImageWrapper.length > 0 && window.colorHtmlSnippet && window.colorHtmlSnippet[colorOptionHandle]){
        if(window.innerWidth <= 820 && pfdImageWrapper.hasClass(`slick-initialized`)) {
          pfdImageWrapper.slick('unslick');
          pfdImageWrapper.html(window.colorHtmlSnippet[colorOptionHandle]);
          setTimeout(()=>{
            this.initSlick(pfdImageWrapper);
          }, 50);
        } else {
          pfdImageWrapper.html(window.colorHtmlSnippet[colorOptionHandle]);
        }
      };
    }
  }

  // ADA: not functioning as a carousel: remove all carousel markup and remove or hide the screen reader only instructions
  removeCarouselInstructions(pfdImageWrapper) {
    pfdImageWrapper.removeAttr('role');
    pfdImageWrapper.removeAttr('aria-label');
    pfdImageWrapper.siblings('.sr-only').remove();
  }
  // ADA: functioning as a carousel: include the carousel markup and screen reader only instructions
  includeCarouselInstructions(pfdImageWrapper) {
    let srOnlyHtml = `<p class="sr-only">This is a carousel. Use Next and Previous buttons to navigate.</p>`;
    pfdImageWrapper.attr({'role': 'region', 'aria-label': 'Product Carousel'});
    if(pfdImageWrapper.siblings('.sr-only').length == 0) {pfdImageWrapper.before(srOnlyHtml);}
  }

  debounce(func, wait) {
    let timeout;
    return function(...args) {
      const later = () => {
        clearTimeout(timeout);
        func.apply(this, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

// 注册自定义元素
customElements.define("product-feature-details", ProductFeatureDetails);
